import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import {
  Button,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'

const ModalBeingSent = ({ show, onClose }) => {
  const intl = useIntl()

  return (
    <Modal show={show} showClose closeOnOverlayClick onClose={onClose}>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarningTitle'
        })}
      />
      <ModalBody>
        {intl.formatMessage({
          id: 'Load.EmailMessageList.MessageIsOnSentWarning'
        })}
      </ModalBody>
      <ModalFoot>
        <Button onClick={onClose} kind='primary'>
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalBeingSent.defaultProps = {
  show: false
}

ModalBeingSent.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ModalBeingSent
